<template>
	
	<div class="article">
		
		<div class="tvwrap w12">
			<div class="tvwrapleft comborder">
		<!-- 		<Html :showTv="showTv" :cctvOrbrtv="cctvOrbrtv" :fromPage='fromPage' :fromInfo='fromInfo' :lminfo="lminfo" :catid="catid" :trans="trans" :lmname="lmname" :arcHtml="arcHtml" :arcTime="arcTime" :arcTitle="arcTitle" :down="down" :up="up" :hotArcs="hotArcs">
					
				</Html> -->
				<div class="html">
						<h2 class="comtitle">
							<strong v-if="fromPage == 'anlihtml' && fromInfo == 'm'">冠领案例</strong>
							<strong v-else-if="fromPage == 'faguihtml' && fromInfo == 'm'">拆迁法规</strong>
							<strong v-else>{{lmname}}</strong>
							<span class="mianbao">当前位置：
								<a href="/" @click.prevent="$router.push('/')">北京冠领律师事务所拆迁官网<em>></em> </a>
				<!-- 				<block v-if="showTv">
									<router-link v-if="cctvOrbrtv == 'brtv'" :to="{path:'/tv/'+cctvOrbrtv+'.html'}">冠领在BRTV<em>></em></router-link>
									<router-link v-if="cctvOrbrtv == 'cctv'" :to="{path:'/tv/'+cctvOrbrtv+'.html'}">冠领在CCTV<em>></em></router-link>
								</block> -->
								
								
								
								<router-link :to="{path:lminfo.path}">{{lminfo.name}}<em>></em></router-link>
								
								<router-link v-if="fromInfo != 'm'" to="/noticle/list/kaiting.html">{{lmname}}<em>></em></router-link>
							</span> 
						</h2>
						<div class="content">
							<h2 class="contentHeader">{{arcTitle}}</h2>
							<div class="contenttitle">
								<span>文章来源：北京冠领律师事务所</span>  
								<!-- <span>阅读：{{count}}</span>  -->
								<span>发布时间：{{arcTime}}</span>  
								<span>字体： [
									<em v-for="item,index in changeFont" :key="item.id" :class="idx == index ? 'activeColor' : ''" @click="change(index,item.size)">{{item.name}}</em>
									]</span>  
							</div>
							 <div class="contentbox"  v-html="arcHtml" ref="htmlnode"></div>
						</div>
				 		<div class="shangxia" v-if="fromInfo != 'm'">
								<a href="javascript:void(0)" v-if="up == null" >上一篇：没有了</a>
								<router-link :to="{path:up.id+'.html'}" v-else :title="up.title">上一篇：{{up.title}}</router-link>
				
								<a href="javascript:void(0)" v-if="down == null" >下一篇：没有了</a>
								<router-link :to="{path:down.id+'.html'}" v-else :title="down.title">下一篇：{{down.title}}</router-link>
						</div> 
						<div class="tuijian" v-if="fromInfo != 'm'">
							<strong>相关推荐{{a}}</strong>
							<ul>
								<li v-for="item in hotArcs" :key="item.id">
									<router-link :to="{path:item.id+'.html'}">{{item.title}}</router-link>
								</li>
							</ul>
						</div>
						
					</div>
			</div>
			
			<Aside :showTv="showTv" :cctvOrbrtv="cctvOrbrtv" :lmname="lmname" :fromPage='fromPage' :fromInfo='fromInfo'/>

		</div>
	</div>
</template>

<script>
	import $ from 'jquery'
	import Aside from "../components/Aside"
	import {request} from '../network/request.js'
	import GLOBAL from '../global/global.js'
	import {mapState,mapGetters} from 'vuex'
	import { title } from '../global/common.js'
	export default{
		name:'Article',
		props:['lmname','id','a'],
		components:{
			Aside
		},
		data(){
			return {
				trans:true,
				arcTitle:'',
				arcHtml:[],
				arcTime:'',
				url:'',
				fromInfo:'',
				fromPage:'',
				host:'http://api.guanlingls.com',
				catid:0,
				down:'',
				up:'',
				hotArc:'',
				downOrupUrl:'',
				fromtype:'',
				hotArcs:[],
				lminfo:[],
				cctvOrbrtv:'brtv',
				showTv:false,
				idx:1,
				changeFont:[
					{name:'大'},
					{name:'中'},
					{name:'小'}
				]
			}
		},
		
		methods:{
			change(id){
				this.idx = id
				let className = ''
				if(id == 0){
					className = 'big'
				}else if(id == 1){
					className = 'mid'
				}else{
					className = 'lit'
				}
				this.$refs.htmlnode.classList.value = className
			},
			gotoList(){
				let that = this
				let name = this.$route.name
				let url = ''
				// console.log(that.lmname)
				switch(name){
				
					
					case 'noticlehtml':
					url = that.lmname == '冠领在开庭' ? '/noticle/list/kaiting' : '/noticle/list/banan'
					break;
					
			
				}
				
				
				this.$router.push({
					path:url+'.html'
				})
			},
			//获取文章内容
			getArcInfo(url){
				let that = this
				request({
					url: that.url,
					responseType: 'json',
					transformResponse:[function(data){
						let jsondata = JSON.parse(data)
						// console.log(jsondata)
						that.arcHtml = ''
						if(jsondata['code'] == 200){
							if(that.fromInfo == 'm'){
								// console.log(jsondata['data']['body'])
								if(jsondata['data']['body'].length > 20){
									that.trans = true
									that.arcHtml = jsondata['data']['body']
								}else{
									that.arcHtml = jsondata['data']['content'].replace(/\s(src=")/g, " $1"+that.host+"")
								}
								that.arcTitle = jsondata['data']['title']
								that.arcTime = jsondata['data']['create_time'].split(' ')[0]
							}else{
								that.arcTitle = jsondata['data']['title']
								that.catid = jsondata['data']['catid']
								that.arcTime = jsondata['data']['create_time'].split(' ')[0]
				
									jsondata['data']['content'] = jsondata['data']['content'].replace('http://api.guanlingls.com','')
									that.arcHtml = jsondata['data']['content'].replace(/\s(src=")/g, " $1"+that.host+"")
								
								
								// console.log(jsondata['data'])
								that.getlmname(jsondata['data']['catid'])
								that.relevant(jsondata['data']['catid'])
								that.preOrnext(jsondata['data']['id'],jsondata['data']['catid'])
								//判断brtv还是cctv
								let catid = jsondata['data']['catid']
								// console.log(catid)
								if(catid == 48 || catid == 49 || catid == 50 || catid == 51 || catid == 52 || catid == 53 || catid == 54){
									that.cctvOrbrtv = 'cctv'
								}
							}
						}
					}]
				})
			},
			//栏目名称
			getlmname(lmid){
				let that = this
				request({
					url: '/Category/read?id='+lmid,
					responseType: 'json',
					transformResponse:[function(data){
						let jsondata = JSON.parse(data)
						// console.log(jsondata);
						if(jsondata['code'] == 200){
							that.lmname = []
							let beforeData = jsondata['data']
							that.lmname = beforeData['name']
							document.title = beforeData['name']+'-'+title
						}
					}]
				})
			},
			//上下篇
			preOrnext(id,catid){
				let that = this
				request({
					url: that.downOrupUrl+'id='+id+'&catid='+catid,
					responseType: 'json',
					transformResponse:[function(data){
						let jsondata = JSON.parse(data)
						// console.log(jsondata);
						if(jsondata['code'] == 200){
							that.down = jsondata['data']['down']
							that.up = jsondata['data']['up']
						}
					}]
				})
			}, 
			//相关推荐
			relevant(id){
				let that = this
				request({
					url: '/gonggao/liebiao?xid=1&zmid=39&page=1&page_size=10',
					responseType: 'json',
					transformResponse:[function(data){
						
						let jsondata = JSON.parse(data)	
						if(jsondata['code'] == 200){
							// console.log(jsondata['data']['data'])
							let newData = jsondata['data'].filter(item => {
								return item['title'] != that.arcTitle
							})
							that.hotArcs = newData
						}
					}]
				})
			},
			commonFun(){
				// console.log(this.$route)
				let ofPage = this.$route.name
				let biaoshi = this.$route.params.biaoshi

			
				// console.log(this.$route)
				
				
				let id = this.$route.params.id
				this.fromInfo = biaoshi
				this.fromPage = ofPage
				this.lminfo = this.$route.meta.parent[0]
				if(biaoshi == 'm'){
					biaoshi = 'zm'
					this.fromtype = 'm'
					this.host = 'http://api.guanlingls.com'
				}else if(biaoshi == 'v'){
					biaoshi = ''
					this.fromtype = 'v'
					this.host = 'http://api.guanlingls.com'
				}
				
				
				// console.log(ofPage)
				switch(ofPage){
					case 'noticlehtmlkaiting':
					this.hotArc = '/gonggao/read?'
					this.downOrupUrl = '/gonggao/gonggaonext?'
					this.url = '/gonggao/'+biaoshi+'gonggaolist?id='+id
					break;
				}

				// alert(this.url)
				// console.log(this.url)
				this.getArcInfo(this.url)//文章详情

			},
		},
		computed:{
	
		},
		mounted() {
	
		},
		created(){
			this.commonFun()
			this.arcHtml = ''
			this.arcTitle = ''
		},

		watch:{
		  $route(to, from){
			this.commonFun()
			this.arcHtml = ''
			this.arcTitle = ''
		  }
		}
	}
</script>

<style lang="scss" scoped>
	
	h2.comtitle{
	    display: flex;
	    height: 40px;
	    border-bottom: 1px solid #fad4ba;
	    justify-content: flex-start;
	    align-items: center;
	    background: linear-gradient(to bottom, #fcf3e3 5%, #f6e2bb 45%,#f6e2bb 55%, #fcf3e3 100%);
		color: #333;
		font-size: 14px;
	}
		.big{
			font-size: 18px !important;
		}
	
		.mid{
			font-size: 16px !important;
		}
		.lit{
			font-size: 14px !important;
		}
		.activeColor{
			color: #c21a20;
			font-weight: bold;
		}
		.shangxia{
			padding: 80px 50px 50px;
			display: flex;
			justify-content: space-between;
			a{
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				margin-right: 10px;
			}
		}
		.tuijian{
			padding: 0 50px;
			ul{
				margin-top: 30px;
			}
			li{
				margin: 10px 0;
			}
		}
		.html{
			padding-bottom: 80px;

		}
	        .content{
	            margin-top: 40px;
	            padding: 0 35px;
				.videobox{
					display: flex;
					justify-content: center;
					video{
						width: 600px;
						margin-top: 50px;
						margin-bottom: 50px;
					}
				}
	            h2{
	                text-align: center;
	                font-size: 34px;
	                color: #333;
	                font-weight: normal;
	            }
	            .contenttitle{
	                display: flex;
	                justify-content: space-evenly;
	                margin: 20px 0;
	                border-bottom: 1px solid #eeecec;
	                padding-bottom: 15px;
	                span{
	                    font-size: 12px;
	                    color: #666666;
						
	                    em{
	                        padding: 0 2px;
	                        cursor: pointer;
	                        transition: color .1s linear ;
	                    }
	                    em.active{
	                        color: #c21a20;
	                    }
	                    em:hover{
	                        color: #c21a20;
	                    }
	                }
	            }
	
	        }
.tvwrap .tvwrapleft h2.comtitle a{
	margin-right: 0;
}
.comtitle strong{
	width: auto !important;
	padding: 0 50px!important;
	font-size: 16px;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
	text-shadow: 0 0 1px #fff;
}
.videobox{
	width: 600px;
	background: #333;
	margin: 0 auto;
	video{
		width: 600px;
	}
}
.tvwrap{
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    .tvwrapleft{
        width: 915px;
        background-color: #fff;
        h2.comtitle{
            justify-content: flex-start;
            strong{
                width: 220px;
                margin-left: 5px;
            }
            strong::after{
                left: 19%;
            }
            span{
                font-size: 14px;
                margin-left: 15px;
                
            }
           
        }

        .shangxia{
            padding: 0 35px;
            margin-top: 60px;
            a{
                display: block;
                color: #545455;
                line-height: 40px;
                position: relative;
                text-indent: 10px;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
            }
            a::after{
                content: "";
                width: 4px;
                height: 4px;
                border-radius: 50%;
                position: absolute;
                left: 0;
                top: 50%;
                background: #626263;
            }
        }
        .tuijian{
            padding: 0 35px 30px; 
            margin-top: 60px;
            strong{
                font-size: 18px;
                font-weight: normal;
            }
            ul{
                li{
                    color: #545455;
                    list-style-type: disc;
                    margin-left: 16px;
                    padding-top: 10px;
                    line-height: 30px;
                    font-size: 12px;
                    a{
                        font-size: 16px;
                    }
                }
            }  
        }

        
    }




}
</style>